import Skeleton from "@mui/material/Skeleton"

export default function TextSkeleton({ width, height = "3em" }) {
  return (
    <Skeleton
      variant="text"
      sx={{ display: "inline-block", width: `${width}em`, height }}
    />
  )
}

export function LoadingTextSkeleton({
  width,
  height = "3em",
  isLoading,
  children,
}) {
  return isLoading ? <TextSkeleton width={width} height={height} /> : children
}
